import { AbstractOfficerForm } from '@shared/classes/officer/abstract-officer-form.class';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OfficerAuditorFormType } from '@modules/officer/models/form/officer-auditor-form-type';

export class OfficerAuditorForm extends AbstractOfficerForm {
  officerForm: FormGroup<OfficerAuditorFormType>;

  createOfficerForm(): void {
    this.officerForm = this.formBuilder.group<OfficerAuditorFormType>({
      auditorName: new FormControl<string | null>('', Validators.required),
    });
  }

  setEditData(): void {
    // TODO: implement when auditor edit flow is introduced.
  }
}
